import $http from '$http'
import {
    lg,
    cloneDeep,
    util,
    isCorrectVal,
    isDate
} from 'utils';

export default {
    methods: {
        getDataList() {
            this.lists = [];
            this.loading2 = true; //拼命加载中显示
            $http.get('api/Agent/GetFormatAgentList', Object.assign({}, this.query, this.filterData)).then(res => {
                let {
                    StateCode,
                    StateMsg,
                    Data,
                    Cnt
                } = res.data;
                util.doResult(this, res, () => {
                    this.query.total = Cnt;
                    this.loading2 = false; //拼命加载中隐
                    this.lists = Data;
                });
            });
        },
    }
};


// WEBPACK FOOTER //
// ./src/pages/CRMAgentAccountManage/services.js